export default __webpack_public_path__ + "static/broadcastImg1-913a24dbc1e23680c379f99939b20615.webp";